import { render, staticRenderFns } from "./ldx-detail.vue?vue&type=template&id=a933996a&scoped=true&"
import script from "./ldx-detail.vue?vue&type=script&lang=js&"
export * from "./ldx-detail.vue?vue&type=script&lang=js&"
import style0 from "./ldx-detail.vue?vue&type=style&index=0&id=a933996a&prod&scoped=true&lang=css&"
import style1 from "./ldx-detail.vue?vue&type=style&index=1&id=a933996a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a933996a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContent,VDivider,VRow})
